//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SfIcon from "~/themes/fiskarsMoominDefault/components/components/atoms/SfIcon/SfIcon.vue";
import { computed, watch } from "@nuxtjs/composition-api";
import {
  validateLength,
  validateLowerCapitalLetter,
  validateNumber,
  validateSpecialCharacter
} from "~/helpers/validation-utils";

export default {
  name: "PasswordRequirements",
  components: { SfIcon },
  emits: ["checkPasswordValidation"],
  props: {
    password: {
      type: String
    },
    passwordRequirementsLabel: {
      type: String,
    },
    requirementEightCharacters: {
      type: String,
    },
    requirementSpecialCharacter: {
      type: String,
    },
    requirementUpperLowerCase: {
      type: String,
    },
    requirementContainsNumber: {
      type: String,
    },
  },
  setup(props, {emit}) {
    const validationRules = [
      {
        requirement: 'requirementSpecialCharacter',
        validator: validateSpecialCharacter
      },
      {
        requirement: 'requirementEightCharacters',
        validator: validateLength
      },
      {
        requirement: 'requirementUpperLowerCase',
        validator: validateLowerCapitalLetter
      },
      {
        requirement: 'requirementContainsNumber',
        validator: validateNumber
      }
    ];

    const isRuleValid = (rule) => !props[rule.requirement] || rule.validator(props.password);

    const passwordValidated = computed(() => validationRules.every((rule) => isRuleValid(rule)));

    const _passwordRequirements = computed(() => validationRules.map((rule) => ({
      key: rule.requirement,
      name: () => props[rule.requirement],
      enabled: () => !!props[rule.requirement],
      validated: () => isRuleValid(rule)
    })));

    watch(passwordValidated, (isValid) => emit('checkPasswordValidation', {isValid}));

    return {
      _passwordRequirements
    };
  }
}
